import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Box, MenuItem, Paper, Select, Snackbar, TextField, Typography } from "@mui/material";
import { Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ConfirmDialog from "../../../../Components/CustomDialog/customdialog";
import { StyledTableCell, StyledTableHead, } from "../../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField, CustomThemeProvider, } from "../../../../Styles/theme/customThemeprovider";
import { IOperSementA2, IOperSementCab } from "../../../../Interfaces/anexos/anexo2/operSementeira";
import { useLocation } from "react-router-dom";
import { del, get, post } from "../../../../Services/tokenConfig";
import { func_print } from "../../../../Func_genericas/func_print";
import BasicPopover from "../../../../Components/Popover";
import { BarraDeFerramentas } from "../../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../../Components/Alert/Alert";
import { AuthContext } from "../../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { IZonaHomogenea } from "../../../../Interfaces/cadernos/zona_homogenea";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../../Func_genericas/valores_estaticos";
interface OperacoesSementeiraForm_prop {
  zona_lista: IZonaHomogenea[]

}
export const OperacoesSementeiraForm: React.FC<OperacoesSementeiraForm_prop> = ({
  zona_lista
}) => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const is_historico = location.state?.is_historico ?? false;


  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<IOperSementCab>();
  const [obj_anexo, set_obj_anexo] = useState<IOperSementA2>();
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
  const [obj_anexo_lista_cabecalho, set_obj_anexo_lista_cabecalho] = useState<IOperSementCab[]>([]);
  const [obj_anexo_lista, set_obj_anexo_lista] = useState<IOperSementA2[]>([]);
  const [flag_criar_novo_anexo, set_flag_criar_novo_anexo] = React.useState(false);
  const [flag_criar_novo_cabecalho, set_flag_criar_novo_cabecalho] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error_area, set_error_area] = useState(false);
  const [message, setMessage] = useState("");
  const [id_do_cabecalho_onde_vai_ser_adicionada_info, set_id_do_cabecalho_onde_vai_ser_adicionada_info] = useState<number>()
  const [error_area_intervencionar, set_error_area_intervencionar] = useState(false);
  const [zona_selecionada, set_zona_selecionada] = useState<IZonaHomogenea>();
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handle_close_adicionar_anexo_cabecalho()
    handle_close_adicionar_anexo()
    set_error_area(false)
    set_obj_anexo_cabecalho(undefined)

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const onInputEditTableChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo(aux_obj_anexo);

    } else {
      if (name === 'area_intervencionar') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_area_intervencionar(true)

        } else {
          set_error_area_intervencionar(false)

        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'area') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_area(true)
        } else {
          set_error_area(false)

        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));
      }

    }
  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo_cabecalho(aux_obj_anexo);

    } else {

      set_obj_anexo_cabecalho((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };
  const handle_delete_anexo = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_dois_operacoes_sementeira_dois/${obj_anexo?.id_sementeira}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista.filter((el) => {
          if (el.id_sementeira !== obj_anexo?.id_sementeira) {
            return el
          }
        })
        set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
        setMessage("Registo eliminado com sucesso!");
        set_obj_anexo(undefined)
        set_zona_selecionada(undefined)
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };
  const handle_delete_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_dois_operacoes_um/${obj_anexo_cabecalho?.id_sementeira_cabecalho}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.filter((el) => {
          if (el.id_sementeira_cabecalho !== obj_anexo_cabecalho?.id_sementeira_cabecalho) {
            return el
          }
        })
        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        setMessage("Registo eliminado com sucesso!");
        set_obj_anexo_cabecalho(undefined)

        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };

  const handle_create_anexo = async () => {

    if (error_area === true) {
      set_error_area(true)
      setMessage("Preenchimento da área é numérico!");
      setOpenSnackError(true);

    } else if (error_area_intervencionar === true) {
      set_error_area_intervencionar(true)
      setMessage("Preenchimento da área a intervencionar é numérico!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "new_reg_anexo_dois_operacoes_sementeira_dois", {
          payload: {
            id_sementeira: 0,
            zona_homo: obj_anexo?.zona_homo === undefined ? '' : obj_anexo?.zona_homo,
            area: obj_anexo?.area === undefined ? 0 : obj_anexo?.area,
            area_intervencionar: obj_anexo?.area_intervencionar === undefined ? 0 : obj_anexo?.area_intervencionar,
            especies: obj_anexo?.especies === undefined ? '' : obj_anexo?.especies,
            id_sementeira_cabecalho: id_do_cabecalho_onde_vai_ser_adicionada_info,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ''
          }
        });

        if (res.status === 200) {
          set_obj_anexo_lista((old) => [...old, res.data.result])
          set_obj_anexo(undefined);
          set_zona_selecionada(undefined)
          set_flag_editado(false)

          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);


          set_flag_criar_novo_anexo(false);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);

        }

        setIsLoading(false);
      } catch (error) {
        func_print("handle_create_anexo", error, true);
        setIsLoading(false);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }

    }
  };
  const handle_create_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_anexo_dois_operacoes_sementeira_um", {
        payload: {
          id_sementeira_cabecalho: 0,
          data: obj_anexo_cabecalho?.data === undefined ? '' : obj_anexo_cabecalho?.data,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ''
        }
      });

      if (res.status === 200) {
        set_obj_anexo_lista_cabecalho((old) => [...old, res.data.result])
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
        set_flag_editado(false)


        set_flag_criar_novo_anexo(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);

      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_create_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);

    }
  };

  const handle_update_anexo = async () => {
    if (error_area === true) {
      set_error_area(true)
      setMessage("Preenchimento da área é numérico!");
      setOpenSnackError(true);

    } else if (error_area_intervencionar === true) {
      set_error_area_intervencionar(true)
      setMessage("Preenchimento da área a intervencionar é numérico!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "update_reg_anexo_operacoes_sementeira_dois", { payload: obj_anexo });

        if (res.status === 200) {
          let lista_aux: any = obj_anexo_lista.map((el) => {
            if (el.id_sementeira !== obj_anexo?.id_sementeira) {
              return el
            } else {
              return res.data.result
            }
          })
          set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
          set_obj_anexo(undefined);
          set_flag_criar_novo_anexo(false)
          set_zona_selecionada(undefined)
          set_flag_editado(false)

          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");

          setOpenSnackError(true);
        }

        setIsLoading(false);
      } catch (error) {
        func_print("handle_update_anexo", error, true);
        setMessage("Erro ao gravar!");

        setOpenSnackError(true);
        setIsLoading(false);
      }
    }

  };
  const handle_update_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);
      func_print('obj_anexo_cabecalho', obj_anexo_cabecalho)

      let res = await post(auth.token.cookie_token, "update_reg_anexo_operacoes_sementeira_um", { payload: obj_anexo_cabecalho });

      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.map((el) => {
          if (el.id_sementeira_cabecalho !== obj_anexo_cabecalho?.id_sementeira_cabecalho) {
            return el
          } else {
            return res.data.result
          }
        })
        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)
        set_flag_editado(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_update_anexo", error, true);
      setMessage("Erro ao gravar!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const handle_escolhe_qual_elimina = async () => {

    if (obj_anexo !== undefined) {

      await handle_delete_anexo()
    } else if (obj_anexo_cabecalho !== undefined) {

      await handle_delete_anexo_cabecalho()
    }
  }


  const get_info = async () => {
    try {
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_anexo_dois_all_sementeira_especies/${location.state.id_rosto}`
      );

      if (res_cabecalho.status === 200) {
        if (res_cabecalho.data.result.length !== 0) {
          set_obj_anexo_lista_cabecalho(res_cabecalho.data.result[0]);
          set_obj_anexo_lista(res_cabecalho.data.result[1]);

        }
      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };



  const handle_close_adicionar_anexo_cabecalho = () => {
    set_obj_anexo_cabecalho(undefined)
    set_flag_criar_novo_cabecalho(false)
  }
  const handle_close_adicionar_anexo = () => {
    set_obj_anexo(undefined)
    set_flag_criar_novo_anexo(false)
    set_zona_selecionada(undefined)

  }

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_zona_selecionada(undefined)

    let aux_obj_zona_homogenea_selecionada = zona_lista.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_zona_selecionada(aux_obj_zona_homogenea_selecionada)

    set_obj_anexo((old: any) => ({
      ...old,
      ['area']: aux_obj_zona_homogenea_selecionada?.area,
      ['zona_homo']: aux_obj_zona_homogenea_selecionada?.zona_homogenea,
    }));
  }

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  return (
    <CustomThemeProvider>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          height: "auto",
          width: "auto",
          margin: 2,
          padding: 2,
        }}
      >
        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <table style={{ width: "75%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={5}
                sx={{
                  fontWeight: 600,
                  fontSize: 16,
                  fontFamily: "candara",
                }}
              >
                <Stack direction="row" alignItems="center">
                  5 - Operações a efetuar nos próximos 3/5 anos
                  <BasicPopover
                    text={
                      "Preencher os campos infra quando aplicável e se justifiquem intervenções na gestão da pastagem para além das identificadas nos quadros 2, 3 e 4 ou quando necessário complementar a informação disponibilizados nos referidos quadros, de acordo com o detalhe disponibilizado nos campos infra.\n\nNo caso do regime ecológico «maneio da pastagem permanente», no preenchimento dos campos deve ser considerado o período de 3 anos.\n\nNo caso da intervenção agroambiental «conservação do solo - pastagens biodiversas, no preenchimento dos campos deve ser considerado o período de 5 anos."
                    }
                  />
                </Stack>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                colSpan={3}
                sx={{
                  fontWeight: 600,
                  fontFamily: "candara",
                  fontSize: 16,
                }}
              >
                <Stack direction="row" alignItems="center">
                  5.1 - Sementeira com espécies pratenses
                  <BasicPopover
                    text={
                      "Quadro a preencher apenas para o regime ecológico «maneio da pastagem permanente», quando aplicável (deve estar alinhado com o previsto no quadro 4).\n\nO quadro deve ser replicado tantas vezes quantos os anos identificados no Quadro 4 como tendo operações de sementeira/ressementeira ou melhoria da pastagem."
                    }
                  />
                </Stack>
              </TableCell>
              <TableCell colSpan={2}>
                <Stack direction="row" sx={{ justifyContent: "end" }}>
             {   is_historico === true ? <></> :

                  <BarraDeFerramentas
                    mostrarBotaoNovo
                    textoBotaoNovo="Adicionar cabeçalho"
                    aoClicarNovo={() => set_flag_criar_novo_cabecalho(true)}

                  />}
                </Stack>
              </TableCell>
            </TableRow>
          </TableHead>


          {flag_criar_novo_cabecalho === true ?
            <TableBody>
              <TableRow>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" alignItems="center">
                    Zona homogénea
                    <BasicPopover
                      text={
                        "Preencher com a zona homogénea indicada no quadro 4 anterior como tendo necessidade de intervenção na Sementeira/ ressementeira/melhoria da pastagem."
                      }
                    />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" alignItems="center">
                    Área (Ha)
                    <BasicPopover
                      text={
                        "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                      }
                    />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead colSpan={2} width={500}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      sx={{ paddingRight: 2, fontFamily: "candara" }}
                    >
                      Ano:
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        views={["year"]}
                        label={
                          <Typography fontFamily="candara" fontSize={14}>
                            Selecionar ano
                          </Typography>
                        }
                        value={obj_anexo_cabecalho?.data === undefined ? null : dayjs(obj_anexo_cabecalho?.data)}
                        onChange={(newValue) => {
                          onInputEditTableChange_cabecalho({
                            target: {
                              name: "data",
                              value: newValue ? newValue.format("YYYY") : "",
                            },
                          });
                        }}
                        minDate={dayjs("2010")}
                        slots={{
                          textField: textFieldProps => <TextField {...textFieldProps} />
                        }}
                      />
                    </LocalizationProvider>
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} width={150}>

                  <ButtonCadernos
                    mostrarBotaoGravar
                    aoClicarGravar={() => handle_create_anexo_cabecalho()}
                    mostrarBotaoCancelar
                    aoClicarCancelar={() => {
                      if (flag_editado) {
                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                      } else {
                        handle_close_adicionar_anexo_cabecalho()
                      }
                    }}
                  />

                </StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead>Área a intervencionar</StyledTableHead>
                <StyledTableHead>Espécies pratenses</StyledTableHead>
              </TableRow>
            </TableBody> : <></>
          }
          {
            obj_anexo_lista_cabecalho.length === 0 ?
              <></>
              :
              obj_anexo_lista_cabecalho?.map((tab, key) => {
                if (obj_anexo_cabecalho?.id_sementeira_cabecalho !== tab.id_sementeira_cabecalho) {

                  return (
                    <TableBody key={key}>
                      <TableRow>
                        <TableCell colSpan={7}>
                          <Stack direction="row" sx={{ justifyContent: "end" }}>
                  {  is_historico === true ? <></> :
                            
                            <BarraDeFerramentas
                              mostrarBotaoNovo
                              textoBotaoNovo="Adicionar informação"
                              aoClicarNovo={() => {
                                set_flag_criar_novo_anexo(true)

                                set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_sementeira_cabecalho)
                              }}
                            />}
                          </Stack>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead rowSpan={2} width={150}>
                          <Stack direction="row" alignItems="center">
                            Zona homogénea
                            <BasicPopover
                              text={
                                "Preencher com a zona homogénea indicada no quadro 1 anterior como tendo necessidade de intervenção na Sementeira/ ressementeira/melhoria da pastagem."
                              }
                            />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} width={150}>
                          Área (Ha)
                          <BasicPopover
                            text={
                              "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead colSpan={2} width={500}>
                          <Stack direction="row" alignItems="center" justifyContent='center'>

                            Ano:
                            <Typography
                              sx={{
                                paddingLeft: 2,
                                fontFamily: "candara",
                                fontWeight: 600,
                              }}
                            >
                              {tab.data}
                            </Typography>
                          </Stack>

                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} width={150}>
                  {  is_historico === true ? <></> :
                        
                          <ButtonCadernos
                            mostrarBotaoEditar
                            aoClicarEditar={() => {
                              set_obj_anexo_cabecalho(tab)
                            }}
                            mostrarBotaoApagar
                            aoClicarApagar={() => {
                              set_obj_anexo_cabecalho(tab)
                              set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                            }}
                          />}
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Área a intervencionar

                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead>Espécies pratenses</StyledTableHead>
                      </TableRow>
                      {
                        id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_sementeira_cabecalho && (flag_criar_novo_anexo === true || obj_anexo_lista.length === 0) ?
                          <TableRow>
                            <StyledTableCell>
                              <Select
                                value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                                label={''}
                                name={'zona_homogenea'}
                                sx={{
                                  fontSize: 14,
                                  fontFamily: "verdana",
                                  minWidth: 200,
                                }}
                                onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                              >

                                {zona_lista.map((item: IZonaHomogenea, key) => {

                                  return (
                                    <MenuItem key={key} value={item.zona_homogenea}>
                                      <Typography
                                        style={{
                                          fontSize: 14,
                                          fontFamily: "candara",
                                        }}
                                      >
                                        {item.zona_homogenea}
                                      </Typography>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="area"
                                value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                                onChange={onInputEditTableChange}
                                error={error_area}
                                helperText={error_area ? "Apenas números são aceites" : ""}

                              />
                            </StyledTableCell>


                            <StyledTableCell>
                              <CustomTextField
                                name="area_intervencionar"
                                value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                                onChange={onInputEditTableChange}
                                error={error_area_intervencionar}
                                helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}

                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="especies"
                                value={obj_anexo?.especies === undefined ? '' : obj_anexo?.especies}
                                onChange={onInputEditTableChange}

                              />
                            </StyledTableCell>
                            <StyledTableCell>

                              <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={() =>
                                  handle_create_anexo()
                                }
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handle_close_adicionar_anexo()
                                  }

                                }} />
                            </StyledTableCell>
                          </TableRow> :
                          <></>

                      }
                      {
                        obj_anexo_lista.length !== 0 ?

                          obj_anexo_lista.map((elem, key1) => {
                            if (tab.id_sementeira_cabecalho === elem.id_sementeira_cabecalho && id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_sementeira_cabecalho && elem.id_sementeira === obj_anexo?.id_sementeira) {
                              return (

                                <TableRow key={key1}>
                                  <StyledTableCell>
                                    <Select
                                      value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                                      label={''}
                                      name={'zona_homogenea'}
                                      sx={{
                                        fontSize: 14,
                                        fontFamily: "verdana",
                                        minWidth: 200,
                                      }}
                                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                                    >

                                      {zona_lista.map((item: IZonaHomogenea, key) => {

                                        return (
                                          <MenuItem key={key} value={item.zona_homogenea}>
                                            <Typography
                                              style={{
                                                fontSize: 14,
                                                fontFamily: "candara",
                                              }}
                                            >
                                              {item.zona_homogenea}
                                            </Typography>
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <CustomTextField
                                      name="area"
                                      value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                                      onChange={onInputEditTableChange}
                                      error={error_area}
                                      helperText={error_area ? "Apenas números são aceites" : ""}

                                    />
                                  </StyledTableCell>

                                  <StyledTableCell>
                                    <CustomTextField
                                      name="area_intervencionar"
                                      value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                                      onChange={onInputEditTableChange}
                                      error={error_area_intervencionar}
                                      helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}

                                    />
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <CustomTextField
                                      name="especies"
                                      value={obj_anexo?.especies === undefined ? '' : obj_anexo?.especies}
                                      onChange={onInputEditTableChange}

                                    />
                                  </StyledTableCell>
                                  <StyledTableCell>

                                    <ButtonCadernos
                                      mostrarBotaoGravar
                                      aoClicarGravar={() =>
                                        handle_update_anexo()
                                      }
                                      mostrarBotaoCancelar
                                      aoClicarCancelar={() => {
                                        if (flag_editado) {
                                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                        } else {

                                          handle_close_adicionar_anexo()
                                        }


                                      }} />
                                  </StyledTableCell>
                                </TableRow>

                              )

                            } else if (tab.id_sementeira_cabecalho === elem.id_sementeira_cabecalho) {
                              return (
                                <TableRow key={key1}>
                                  <StyledTableCell>
                                    {elem.zona_homo}

                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.area.toString().replace('.', ',')}

                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.area_intervencionar.toString().replace('.', ',')}


                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.especies}


                                  </StyledTableCell>


                                  <StyledTableCell>
                                {  is_historico === true ? <></> :

                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        set_obj_anexo(elem)
                                        set_zona_selecionada((old: any) => ({
                                          ...old,
                                          ['zona_homogenea']: elem?.zona_homo,
                                        }))
                                        set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_sementeira_cabecalho)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => {
                                        set_obj_anexo(elem)
                                        set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                      }}
                                    />}
                                  </StyledTableCell>
                                </TableRow>

                              )
                            }
                          })
                          :
                          <></>
                      }
                    </TableBody>
                  )
                } else {
                  return (
                    <TableBody key={key}>

                      <TableRow>
                        <StyledTableHead rowSpan={2} width={150}>
                          <Stack direction="row" alignItems="center">
                            Zona homogénea
                            <BasicPopover
                              text={
                                "Preencher com a zona homogénea indicada no quadro 1 anterior como tendo necessidade de intervenção na Sementeira/ ressementeira/melhoria da pastagem."
                              }
                            />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} width={150}>
                          Área (Ha)
                          <BasicPopover
                            text={
                              "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                            }
                          />
                        </StyledTableHead>
                        <StyledTableHead colSpan={2} width={500}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Typography
                              sx={{ paddingRight: 2, fontFamily: "candara" }}
                            >
                              Ano:
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                views={["year"]}
                                label={
                                  <Typography fontFamily="candara" fontSize={14}>
                                    Selecionar ano
                                  </Typography>
                                }
                                value={obj_anexo_cabecalho?.data === undefined ? null : dayjs(obj_anexo_cabecalho?.data)}

                                onChange={(newValue) => {
                                  onInputEditTableChange_cabecalho({
                                    target: {
                                      name: "data",
                                      value: newValue
                                        ? newValue.format("YYYY")
                                        : "",
                                    },
                                  });
                                }}
                                minDate={dayjs("2010")}
                                slots={{
                                  textField: textFieldProps => <TextField {...textFieldProps} />
                                }}
                              />
                            </LocalizationProvider>
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} width={150}>
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={() => handle_update_anexo_cabecalho()}
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                set_obj_anexo_cabecalho(undefined)
                              }

                            }}
                          />
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Área a intervencionar

                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead>Espécies pratenses</StyledTableHead>


                      </TableRow>
                      {
                        obj_anexo_lista.length !== 0 ?

                          obj_anexo_lista.map((elem, key1) => {
                            if (tab.id_sementeira_cabecalho === elem.id_sementeira_cabecalho && id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_sementeira_cabecalho && elem.id_sementeira === obj_anexo?.id_sementeira) {
                              return (

                                <TableRow key={key1}>
                                  <StyledTableCell>

                                    <Select
                                      value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                                      label={''}
                                      name={'zona_homogenea'}
                                      sx={{
                                        fontSize: 14,
                                        fontFamily: "verdana",
                                        minWidth: 200,
                                      }}
                                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                                    >

                                      {zona_lista.map((item: IZonaHomogenea, key) => {

                                        return (
                                          <MenuItem key={key} value={item.zona_homogenea}>
                                            <Typography
                                              style={{
                                                fontSize: 14,
                                                fontFamily: "candara",
                                              }}
                                            >
                                              {item.zona_homogenea}
                                            </Typography>
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <CustomTextField
                                      name="area"
                                      value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                                      onChange={onInputEditTableChange}
                                      error={error_area}
                                      helperText={error_area ? "Apenas números são aceites" : ""}

                                    />
                                  </StyledTableCell>

                                  <StyledTableCell>
                                    <CustomTextField
                                      name="area_intervencionar"
                                      value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                                      onChange={onInputEditTableChange}
                                      error={error_area_intervencionar}
                                      helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}

                                    />
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <CustomTextField
                                      name="especies"
                                      value={obj_anexo?.especies === undefined ? '' : obj_anexo?.especies}
                                      onChange={onInputEditTableChange}

                                    />
                                  </StyledTableCell>
                                  <StyledTableCell>

                                    <ButtonCadernos
                                      mostrarBotaoGravar
                                      aoClicarGravar={() =>
                                        handle_update_anexo()
                                      }
                                      mostrarBotaoCancelar
                                      aoClicarCancelar={() => {
                                        if (flag_editado) {
                                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                        } else {

                                          handle_close_adicionar_anexo()
                                        }

                                      }} />
                                  </StyledTableCell>
                                </TableRow>

                              )

                            } else if (tab.id_sementeira_cabecalho === elem.id_sementeira_cabecalho) {
                              return (
                                <TableRow key={key1}>
                                  <StyledTableCell>
                                    {elem.zona_homo}

                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.toString().replace('.', ',')}

                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.area_intervencionar.toString().replace('.', ',')}


                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {elem.especies}


                                  </StyledTableCell>


                                  <StyledTableCell>
                                 { is_historico === true ? <></> :

                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        set_obj_anexo(elem)
                                        set_zona_selecionada((old: any) => ({
                                          ...old,
                                          ['zona_homogenea']: elem?.zona_homo,
                                        }))
                                        set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_sementeira_cabecalho)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => {
                                        set_obj_anexo(elem)
                                        set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                      }}
                                    />}
                                  </StyledTableCell>
                                </TableRow>

                              )
                            }
                          })
                          :
                          <></>
                      }
                    </TableBody>
                  )

                }
              }



              )}

        </table>

        <ConfirmDialog
          open={open_dialog_tem_a_certeza_que_quer_eliminar}
          onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
          onConfirm={handle_escolhe_qual_elimina}
          message="Deseja eliminar o registo?"
        />
        <ConfirmDialog
          open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
          onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
          onConfirm={() => handleCloseDialog()}
          message={mensagem_tem_a_certeza_de_apagar_alteracoes}
        />
        
      </TableContainer>
    </CustomThemeProvider>
  );
};
